import { apiClient } from '@/lib/api';
import { conCambioPropio } from '../lib/cambio-propio';
import type {
  HistorialDePrecios,
  ResultadoDeVolverAEstePrecio,
  VueltaRevisada,
} from '../types/historial-de-precios.types';

/** Lote C2b (spec 246 punto 11): el historial de precios de un producto. */
export const historialDePreciosApi = {
  delProducto: async (productId: string): Promise<HistorialDePrecios> =>
    apiClient.get<HistorialDePrecios>(`/api/historial-de-precios/${productId}`),

  /**
   * Antes de volver (D15): las reglas de hoy, el margen y la estrategia.
   * `alPrecioDeAntes` (ronda del 5-oct): deshacer, volver al precio de antes de
   * ese cambio; la revisión dice además si hoy se puede (`deshacible`).
   */
  revisarLaVuelta: async (
    productId: string,
    cambioId: string,
    alPrecioDeAntes = false
  ): Promise<VueltaRevisada> =>
    apiClient.post<VueltaRevisada>(`/api/historial-de-precios/${productId}/volver/revisar`, {
      cambioId,
      ...(alPrecioDeAntes ? { alPrecioDeAntes: true } : {}),
    }),

  /**
   * Vuelve: el precio lo decide el servidor (el de ese cambio o el más cercano
   * que cumple); si no es `precioVisto` (el que decía el botón), 409. Con
   * `alPrecioDeAntes` deshace: 409 si después de ese cambio hubo otro, 422 si
   * no tiene precio de antes.
   */
  volver: async (
    productId: string,
    body: {
      cambioId: string;
      usarElQueCumple: boolean;
      precioVisto: number;
      sacarDeEstrategias: boolean;
      motivo: string | null;
      alPrecioDeAntes?: boolean;
    }
  ): Promise<ResultadoDeVolverAEstePrecio> =>
    conCambioPropio(
      apiClient.post<ResultadoDeVolverAEstePrecio>(
        `/api/historial-de-precios/${productId}/volver`,
        body
      )
    ),
};
